import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useCustomerHistory } from "./CustomerHistoryHook";
import { useCustomerContext } from "../customer/CustomerContext";
// Set the default state values for each context
const CustomerHistoryContext = /*#__PURE__*/createContext({});
export const CustomerHistoryContextProvider = ({
  children,
  delayNonEssentialCalls
}) => {
  const hook = useCustomerHistory(delayNonEssentialCalls);
  const {
    customer
  } = useCustomerContext();
  const {
    stateTracker
  } = useDevLogging();
  const context = useMemo(() => {
    stateTracker.trackState({
      history: hook.history
    });
    return {
      ...hook
    };
  }, [hook.history, customer]);

  // pass the value in provider and return
  return /*#__PURE__*/React.createElement(CustomerHistoryContext.Provider, {
    value: context
  }, children);
};
export const useCustomerHistoryContext = () => {
  return useContext(CustomerHistoryContext);
};
CustomerHistoryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  delayNonEssentialCalls: PropTypes.bool.isRequired
};